// src/features/global/globalSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  merchant_id: null,
};

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setMerchantId: (state, action) => {
      state.merchant_id = action.payload || null;
    },
  },
});

export const { setMerchantId } = globalSlice.actions;
export default globalSlice.reducer;
